import { StyleSheet } from 'aphrodite';
import COLORS from '../../../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    color: `${Color(COLORS.allureOrange).darken(0.12)}`,
    ':active': {
      background: `${Color(COLORS.allureOrange).lighten(0.78)}`,
      border: `1px solid ${Color(COLORS.allureOrange).lighten(0.12)}`,
    }
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/button/orange-button/orange-button-styles.js